import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Typography,
  Paper,
  Grid,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  IconButton,
  Tooltip,
  CircularProgress,
  Card,
  CardContent,
  Avatar,
  useTheme,
  alpha
} from '@mui/material';

import {
  ArrowBack as ArrowBackIcon,
  Edit as EditIcon,
  PictureAsPdf as PdfIcon,
  TableChart as ExcelIcon,
  Email as EmailIcon,
  Receipt as ReceiptIcon,
  Business as BusinessIcon,
  ListAlt as ListAltIcon,
  AttachMoney as AttachMoneyIcon
} from '@mui/icons-material';
import { useParams, useNavigate } from 'react-router-dom';
import factureService from '../../API/factureService';
import AlertBar from '../../Components/AlertBar';
import { useAuth } from '../../Context/AuthContext';
import { motion } from 'framer-motion';
import ButtonAttribute from '../../Components/ButtonAttribute';
import AlertConfimation from '../../Components/AlertConfimation';
import logoBase64 from '../../Images/LogoEBNLogin.png';
const FactureView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [facture, setFacture] = useState(null);
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState({ open: false, message: '', severity: 'info' });
  const theme = useTheme();
  const [FacturesEx, setFacturesEx] = useState([]);
  const [sending, setSending] = useState(false);
  const [loadingPDF, setLoadingPDF] = useState(false);
  const [loadingExcel, setLoadingExcel] = useState(false);
  const [loadingEmail, setLoadingEmail] = useState(false);
  useEffect(() => {
    fetchFacture();
    fetchFactureExcel();
  }, [id]);

  const fetchFacture = async () => {
    try {
      setLoading(true);
      const data = await factureService.getFacture(id);
      setFacture(data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching facture:", error);
      setAlert({
        open: true,
        message: 'Erreur lors du chargement de la facture',
        severity: 'error'
      });
      setLoading(false);
    }
  };

  const fetchFactureExcel = async () => {
    try {
      setLoading(true);
      const data = await factureService.getFactureExcel(id);
      setFacturesEx(data); // store in state
      setLoading(false);
    } catch (error) {
      console.error("Erreur lors du chargement de la facture", error);
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate('/factures');
  };

  const handleEdit = () => {
    navigate(`/factures/edit/${id}`);
  };

  const handleDownloadPDF = async () => {
  
    try {

      setLoadingPDF(true);

      await factureService.generatePDF(facture);

      setAlert({
        open: true,
        message: "PDF généré et téléchargé avec succès",
        severity: "success"
      });

    } catch (error) {

      setAlert({
        open: true,
        message: "Erreur lors de la génération du PDF",
        severity: "error"
      });

    } finally {
      setLoadingPDF(false);
    }
  };



  const handleDownloadExcel = async () => {
    try {
      setLoadingExcel(true);

      await factureService.generateExcelOperations(
        FacturesEx,
        logoBase64 || null
      );

      setAlert({
        open: true,
        message: "Excel généré et téléchargé avec succès",
        severity: "success",
      });

    } catch (error) {

      setAlert({
        open: true,
        message: "Erreur lors de la génération du fichier Excel",
        severity: "error",
      });

    } finally {
      setLoadingExcel(false);
    }
  };



  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleSendEmailClick = () => {
    setConfirmOpen(true);
  };

  const handleConfirmSendEmail = async () => {
    if (sending) return;

    setConfirmOpen(false);
    //setSending(true);
    setLoadingEmail(true);

    try {
      await factureService.sendFactureByEmail(facture.ID_Facture);

      setAlert({
        open: true,
        message: "Facture envoyée par email avec succès",
        severity: "success",
      });

    } catch (error) {

      setAlert({
        open: true,
        message:
          error?.message || "Erreur lors de l'envoi de l'email",
        severity: "error",
      });

    } finally {
      //setSending(false);
      setLoadingEmail(false);
    }
  };



  if (loading) {
    return (
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f8f9fa'
      }}>
        <Paper
          elevation={3}
          sx={{
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderRadius: 2
          }}
        >
          <CircularProgress size={60} thickness={4} sx={{ mb: 2 }} />
          <Typography variant="h6" color="text.secondary">
            Chargement de la facture...
          </Typography>
        </Paper>
      </Box>
    );
  }

  if (!facture) {
    return (
      <>
        <Box sx={{
          padding: { xs: '20px', md: '20px' },
          backgroundColor: "#f8f9fa",
          transition: "padding 0.3s ease-in-out",
          minHeight: "100vh"
        }}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Paper
              elevation={3}
              sx={{
                p: 4,
                borderRadius: 2,
                textAlign: 'center',
                borderLeft: `5px solid ${theme.palette.error.main}`
              }}
            >
              <Typography variant="h5" color="error" gutterBottom>
                Facture non trouvée
              </Typography>
              <Typography variant="body1" color="text.secondary" paragraph>
                La facture que vous recherchez n'existe pas ou a été supprimée.
              </Typography>
              <ButtonAttribute
                type="button"
                Bgcolor="#1976d2"
                color="#fff"
                bgColorHover="#115293"
                ColorHover="#fff"
                startIcon={<ArrowBackIcon />}
                Label="Retour à la liste"
                action={handleBack}
                width="auto"
                height="45px"

              />

            </Paper>
          </motion.div>
        </Box>
      </>
    );
  }

  const getStatusColor = (status) => {
    switch (status) {
      case 'brouillon':
        return theme.palette.grey[500];
      case 'envoyée':
        return theme.palette.primary.main;
      case 'payée':
        return theme.palette.success.main;
      default:
        return theme.palette.grey[500];
    }
  };
  const FullPageLoader = ({ loading, text = "Chargement..." }) => {
    if (!loading) return null;

    return (
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(255,255,255,0.7)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999,
          backdropFilter: "blur(3px)"
        }}
      >
        <Box sx={{ textAlign: "center" }}>
          <CircularProgress size={60} />
          <Typography sx={{ mt: 2, fontWeight: "bold" }}>
            {text}
          </Typography>
        </Box>
      </Box>
    );
  };
  return (
    <>
      <FullPageLoader
        loading={loadingPDF}
        text="Génération du PDF..."
      />
      <FullPageLoader
        loading={loadingExcel}
        text="Génération du Excel..."
      />
      <FullPageLoader
        loading={loadingEmail}
        text="Envoi de la facture par email..."
      />
      <Box sx={{
        padding: { xs: '20px', md: '20px' },
        backgroundColor: "#f8f9fa",
        transition: "padding 0.3s ease-in-out",
        minHeight: "100vh"
      }}>
        <AlertBar
          open={alert.open}
          textContent={alert.message}
          alertColor={alert.severity}
          onClose={() => setAlert({ ...alert, open: false })}
        />

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          {/* En-tête de la facture */}
          <Paper
            elevation={3}
            sx={{

              border: '1px solid #e5e7eb4b',
              borderRadius: '32px',
              padding: { xs: '20px', md: '30px' },
              marginBottom: '20px',
              boxShadow: "0 4px 6px rgba(99, 102, 241, 0.2)",
              p: 3,
              mb: 3,

              background: `linear-gradient(to right, ${alpha(getStatusColor(facture.statut), 0.1)}, ${alpha(getStatusColor(facture.statut), 0.05)})`,
              borderLeft: `5px solid ${getStatusColor(facture.statut)}`
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: { xs: 2, md: 0 } }}>
                <Avatar sx={{ bgcolor: getStatusColor(facture.statut), mr: 2 }}>
                  <ReceiptIcon />
                </Avatar>
                <Box>
                  <Typography variant="h4" component="h1" fontWeight="bold">
                    Facture {facture.numero_facture}
                  </Typography>
                  <Chip
                    label={facture.statut.toUpperCase()}
                    sx={{
                      mt: 1,
                      bgcolor: getStatusColor(facture.statut),
                      color: 'white',
                      fontWeight: 'bold'
                    }}
                  />
                </Box>
              </Box>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <ButtonAttribute
                  type="button"
                  Bgcolor="transparent"
                  color="#1976d2"
                  bgColorHover="rgba(25,118,210,0.08)"
                  ColorHover="#1976d2"
                  startIcon={<ArrowBackIcon />}
                  Label="Retour"
                  action={handleBack}
                  width="auto"
                  height="40px"
                  sx={{
                    border: "1.5px solid #1976d2",
                    borderRadius: "8px",
                    fontWeight: 500,
                    px: 2,
                    py: 1
                  }}
                />

                <ButtonAttribute
                  type="button"
                  Bgcolor="#1976d2"
                  color="#fff"
                  bgColorHover="#115293"
                  ColorHover="#fff"
                  startIcon={<EditIcon />}
                  Label="Modifier"
                  action={handleEdit}
                  width="auto"
                  height="40px"
                  sx={{
                    borderRadius: "8px",
                    fontWeight: 500,
                    px: 2,
                    py: 1,
                    boxShadow: "0 4px 10px rgba(0,0,0,0.15)"
                  }}
                />

              </Box>
            </Box>
          </Paper>


          {/* Actions rapides */}
          <Box sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap' }}>
            <ButtonAttribute
              type="button"
              Bgcolor={theme.palette.error.main}
              color="#fff"
              bgColorHover={theme.palette.error.dark}
              ColorHover="#fff"
              startIcon={<PdfIcon />}
              Label="Télécharger PDF"
              action={handleDownloadPDF}
              width="auto"
              height="40px"
              sx={{
                borderRadius: "8px",
                fontWeight: 500,
                px: 2,
                py: 1
              }}
            />

            <ButtonAttribute
              type="button"
              Bgcolor="#2E7D32"
              color="#fff"
              bgColorHover="#1B5E20"
              ColorHover="#fff"
              startIcon={<ExcelIcon />}
              Label="Exporter Excel"
              action={handleDownloadExcel}
              width="auto"
              height="40px"
              sx={{
                borderRadius: "8px",
                fontWeight: 500,
                px: 2,
                py: 1
              }}
            />

            <ButtonAttribute
              type="button"
              Bgcolor={theme.palette.info.main}
              color="#fff"
              bgColorHover={theme.palette.info.dark}
              ColorHover="#fff"
              startIcon={<EmailIcon />}
              Label="Envoyer par email"
              action={handleSendEmailClick}
              width="auto"
              height="40px"
              sx={{
                borderRadius: "8px",
                fontWeight: 500,
                px: 2,
                py: 1
              }}
            />

          </Box>

          <Grid container spacing={3}>
            {/* Informations de la facture */}
            <Grid item xs={12} md={6}>
              <Card elevation={3} sx={{
                height: '100%', backgroundColor: '#ffffff',
                border: '1px solid #e5e7eb4b',
                borderRadius: '32px',
                padding: { xs: '20px', md: '30px' },
                marginBottom: '20px',
                boxShadow: "0 4px 6px rgba(99, 102, 241, 0.2)"
              }}>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <ReceiptIcon sx={{ mr: 1, color: theme.palette.primary.main }} />
                    <Typography variant="h6" fontWeight="bold">
                      Informations de la facture
                    </Typography>
                  </Box>
                  <Divider sx={{ mb: 2 }} />
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Typography variant="subtitle2" color="text.secondary">
                        Numéro de facture
                      </Typography>
                      <Typography variant="body1" fontWeight="medium">
                        {facture.numero_facture}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="subtitle2" color="text.secondary">
                        Date de facture
                      </Typography>
                      <Typography variant="body1" fontWeight="medium">
                        {facture.date_facture ? new Date(facture.date_facture).toLocaleDateString() : 'Non définie'}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="subtitle2" color="text.secondary">
                        Période
                      </Typography>
                      <Typography variant="body1" fontWeight="medium">
                        {facture.periode_debut ? new Date(facture.periode_debut).toLocaleDateString() : 'Non définie'} -
                        {facture.periode_fin ? new Date(facture.periode_fin).toLocaleDateString() : 'Non définie'}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="subtitle2" color="text.secondary">
                        Date d'échéance
                      </Typography>
                      <Typography variant="body1" fontWeight="medium">
                        {facture.date_echeance ? new Date(facture.date_echeance).toLocaleDateString() : 'Non définie'}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="subtitle2" color="text.secondary">
                        Conditions de paiement
                      </Typography>
                      <Typography variant="body1" fontWeight="medium">
                        {facture.conditions_paiement || 'Non définies'}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="subtitle2" color="text.secondary">
                        Notes
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          p: 1.5,
                          bgcolor: alpha(theme.palette.primary.main, 0.05),
                          borderRadius: 1,
                          borderLeft: `3px solid ${theme.palette.primary.main}`
                        }}
                      >
                        {facture.notes || 'Aucune note'}
                      </Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>

            {/* Informations du client */}
            <Grid item xs={12} md={6}>
              <Card elevation={3} sx={{
                height: '100%', backgroundColor: '#ffffff',
                border: '1px solid #e5e7eb4b',
                borderRadius: '32px',
                padding: { xs: '20px', md: '30px' },
                marginBottom: '20px',
                boxShadow: "0 4px 6px rgba(99, 102, 241, 0.2)"
              }}>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <BusinessIcon sx={{ mr: 1, color: theme.palette.secondary.main }} />
                    <Typography variant="h6" fontWeight="bold">
                      Informations du client
                    </Typography>
                  </Box>
                  <Divider sx={{ mb: 2 }} />
                  {facture.client ? (
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Typography variant="subtitle2" color="text.secondary">
                          Nom / Raison sociale
                        </Typography>
                        <Typography variant="body1" fontWeight="medium">
                          {facture.client?.Raison_sociale || facture.client?.Nom || 'N/A'}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="subtitle2" color="text.secondary">
                          Adresse
                        </Typography>
                        <Typography variant="body1" fontWeight="medium">
                          {facture.client?.Adresse || 'N/A'}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                          ICE
                        </Typography>
                        <Typography variant="body1" fontWeight="medium">
                          {facture.client?.ICE || 'N/A'}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                          IF
                        </Typography>
                        <Typography variant="body1" fontWeight="medium">
                          {facture.client?.IF || 'N/A'}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                          Email
                        </Typography>
                        <Typography variant="body1" fontWeight="medium">
                          {facture.client?.Email || 'N/A'}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                          Téléphone
                        </Typography>
                        <Typography variant="body1" fontWeight="medium">
                          {facture.client?.Contact || 'N/A'}
                        </Typography>
                      </Grid>
                    </Grid>
                  ) : (
                    <Box sx={{ p: 2, textAlign: 'center' }}>
                      <Typography variant="body1" color="text.secondary">
                        Informations client non disponibles
                      </Typography>
                    </Box>
                  )}
                </CardContent>
              </Card>
            </Grid>

            {/* Lignes de facturation */}
            <Grid item xs={12}>
              <Card elevation={3} sx={{
                backgroundColor: '#ffffff',
                border: '1px solid #e5e7eb4b',
                borderRadius: '32px',
                padding: { xs: '20px', md: '30px' },
                marginBottom: '20px',
                boxShadow: "0 4px 6px rgba(99, 102, 241, 0.2)", height: '100%'
              }}>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <ListAltIcon sx={{ mr: 1, color: theme.palette.info.main }} />
                    <Typography variant="h6" fontWeight="bold">
                      Lignes de facturation
                    </Typography>
                  </Box>
                  <Divider sx={{ mb: 2 }} />
                  <TableContainer>
                    <Table sx={{ minWidth: 650 }}>
                      <TableHead>
                        <TableRow sx={{ bgcolor: alpha(theme.palette.primary.main, 0.05) }}>
                          <TableCell sx={{ fontWeight: 'bold' }}>Description</TableCell>
                          <TableCell sx={{ fontWeight: 'bold' }}>ID Voyage</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>Quantité</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>Prix unitaire</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>Montant HT</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>TVA (%)</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>TVA 1(%)</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>Montant TVA</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>Montant TTC</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {facture.lignes && facture.lignes.length > 0 ? (
                          facture.lignes.map((ligne, index) => (
                            <TableRow
                              key={ligne.ID_Ligne || index}
                              sx={{
                                '&:nth-of-type(odd)': { bgcolor: alpha(theme.palette.primary.main, 0.02) },
                                '&:hover': { bgcolor: alpha(theme.palette.primary.main, 0.05) }
                              }}
                            >
                              <TableCell>{ligne.description || 'N/A'}</TableCell>
                              <TableCell>{ligne.ID_Voyage || 'N/A'}</TableCell>
                              <TableCell align="right">{ligne.quantite || 0}</TableCell>
                              <TableCell align="right">{(ligne.prix_unitaire || 0).toLocaleString()} MAD</TableCell>
                              <TableCell align="right">{(ligne.montant_ht || 0).toLocaleString()} MAD</TableCell>
                              <TableCell align="right">{ligne.taux_tva || 0}%</TableCell>
                              <TableCell align="right">{ligne.taux_tva1 || 0}%</TableCell>
                              <TableCell align="right">{(ligne.montant_tva || 0).toLocaleString()} MAD</TableCell>
                              <TableCell align="right">{(ligne.montant_ttc || 0).toLocaleString()} MAD</TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={8} align="center" sx={{ py: 4 }}>
                              <Typography variant="body1" color="text.secondary">
                                Aucune ligne de facturation
                              </Typography>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Card>
            </Grid>

            {/* Récapitulatif */}
            <Grid item xs={12} md={4} width={"40%"} justifyContent="flex-end"  >
              <Card
                elevation={3}
                sx={{
                  backgroundColor: '#ffffff',
                  border: '1px solid #e5e7eb4b',
                  borderRadius: '32px',
                  padding: { xs: '20px', md: '30px' },
                  marginBottom: '20px',
                  boxShadow: "0 4px 6px rgba(99, 102, 241, 0.2)",



                }}
              >
                <CardContent>
                  <Grid container justifyContent="center">
                    <Grid item xs={12}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <AttachMoneyIcon sx={{ mr: 1, color: theme.palette.success.main }} />
                        <Typography variant="h6" fontWeight="bold">
                          Récapitulatif
                        </Typography>
                      </Box>
                      <Divider sx={{ my: 1 }} />
                      <Box sx={{
                        p: 2,
                        borderRadius: 2,
                        bgcolor: alpha(theme.palette.background.paper, 0.7)
                      }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                          <Typography variant="body1">Montant HT:</Typography>
                          <Typography variant="body1" fontWeight="bold">
                            {(facture.montant_ht || 0).toLocaleString()} MAD
                          </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                          <Typography variant="body1">TVA:</Typography>
                          <Typography variant="body1" fontWeight="bold">
                            {(facture.montant_tva || 0).toLocaleString()} MAD
                          </Typography>
                        </Box>
                        <Divider sx={{ my: 1 }} />
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                          <Typography variant="h6" color="primary">Total TTC:</Typography>
                          <Typography variant="h6" fontWeight="bold" color="primary">
                            {(facture.montant_ttc || 0).toLocaleString()} MAD
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </motion.div>
      </Box>
      <AlertConfimation
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        ChildrenContent={
          <Box textAlign="center">
            <Typography variant="h6" fontWeight="bold" mb={2}>
              Confirmer l’envoi
            </Typography>

            <Typography mb={3}>
              Voulez-vous envoyer la facture
              <strong> {facture.numero_facture} </strong>
              par email ?
            </Typography>

            <Box display="flex" justifyContent="center" gap={2}>

              <ButtonAttribute
                Label="Annuler"
                width="130px"
                color="inherit"
                bgColor="#e53935"           // red
                hoverColor="#b71c1c"        // dark red
                action={() => setConfirmOpen(false)}
              />

              <ButtonAttribute
                Label={"Envoyer"}
                bgColor="#1e88e5"           // blue
                hoverColor="#1565c0"        // dark blue
                action={() => handleConfirmSendEmail()}
              />

            </Box>
          </Box>
        }
      />
      <>
        {sending && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "rgba(0,0,0,0.35)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999
            }}
          >
            <motion.div
              animate={{ rotate: 360 }}
              transition={{
                repeat: Infinity,
                duration: 1,
                ease: "linear"
              }}
              style={{
                width: 60,
                height: 60,
                border: "6px solid white",
                borderTop: "6px solid #1D4ED8",
                borderRadius: "50%"
              }}
            />
          </motion.div>
        )}
      </>

    </>
  );
};

export default FactureView;
